/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/
  
import { HTMLAttributes, useEffect, useState } from 'preact/compat';
import { Container } from '@adobe-commerce/elsie/lib';
import { NegotiableQuoteModel } from '@/quote-management/data/models/negotiable-quote-model';
import { events } from '@adobe-commerce/event-bus';
import { QuoteHistoryLog as QuoteHistoryLogComponent } from '@/quote-management/components/QuoteHistoryLog';

export interface QuoteHistoryLogProps extends HTMLAttributes<HTMLDivElement> {
  quoteData?: NegotiableQuoteModel;
}
    
export const QuoteHistoryLog: Container<QuoteHistoryLogProps> = ({ quoteData: initialData, ...props }) => {

  const [quoteData, setQuoteData] = useState<NegotiableQuoteModel | undefined>(
    initialData
  );

  useEffect(() => {
    const quoteDataEvent = events.on(
      'quote-management/quote-data',
      (data: { quote: NegotiableQuoteModel }) => {
        setQuoteData(data.quote);
      },
      {
        eager: true,
      }
    );
    return () => quoteDataEvent?.off();
  }, []);

  if (!quoteData) {
    return null;
  }

  return (
    <div {...props}>
      <QuoteHistoryLogComponent 
        history={quoteData.history}
        items={quoteData.items}
        buyer={quoteData.buyer}
        salesRepName={quoteData.salesRepName}
      />
    </div>
  );
};
